export default __webpack_public_path__ + "static/media/triangle_down.ee727a97.svg";